import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { TableDirective } from '../../directives/table-directive';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from '../../app/models/User';
import { CardTransaction } from '../../app/models/CardTransaction';
import { Storage } from '../../../node_modules/@ionic/storage';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'page-register-activity-transactions',
  templateUrl: 'register-activity-transactions.html',
})
export class RegisterActivityTransactionsPage {
  @ViewChild(TableDirective)
  private table: TableDirective;

  private pageName: string = 'page-register-activity-transactions';
  private registerActivityUuid: string;
  private currentActivity: RegisterActivity;
  private openingOperator: User;
  private closingOperator: User;
  private currentTransactions: CardTransaction[] = [];
  private navControllerService: NavControllerService;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private userService: UserService,
    private app: App,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.registerActivityUuid = this.navParams.get('registerActivityUuid');
    this.currentActivity = new RegisterActivity();
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.loadRegisterActivity();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  private loadRegisterActivity() {
    this.backendService.getRegisterActivity(this.registerActivityUuid).subscribe(
      (data: RegisterActivity) => {
        this.currentActivity = data;
        this.getOpeningOperator(data.openingOperator.uuid);
        if (data.closeDate) {
          this.getClosingOperator(data.closingOperator.uuid);
          this.loadTransactions();
        } else {
          this.backendService.calculateRegisterActivity(data).subscribe(
            (calculated: RegisterActivity) => {
              this.currentActivity = calculated;
              this.loadTransactions();
            },
            (err: HttpErrorResponse) => {}
          );
        }
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private getOpeningOperator(operatorUuid) {
    this.userService.getUser(operatorUuid).subscribe(
      (user: User) => {
        this.openingOperator = user;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private getClosingOperator(operatorUuid) {
    this.userService.getUser(operatorUuid).subscribe(
      (user: User) => {
        this.closingOperator = user;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadTransactions() {
    this.backendService.getRegisterActivityTransactions(this.currentActivity.uuid).subscribe(
      (transactions) => {
        this.currentTransactions = transactions;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }
  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showRegisterActivitiesPage() {
    this.navControllerService.showRegisterActivitiesPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/register-activity-transactions/register-activity-transactions.ts